import { add } from './add';
import { changeEditingName } from './changeEditingName';
import { clear } from './clear';
import { update } from './update';
import { findOne } from './findOne';
import { findItunes } from './findItunes';
import { importFromItunes } from './importFromItunes';
import { importTrackFromItunes } from './importTrackFromItunes';
import { search } from './search';
import { searchItunes } from './searchItunes';
import { remove } from './remove';

export const libraryActions = {
  add,
  changeEditingName,
  clear,
  findOne,
  findItunes,
  importFromItunes,
  importTrackFromItunes,
  remove,
  search,
  searchItunes,
  update,
};
